export default {
    path: 'device_device',
    name: 'device_device',
    component: r => require.ensure([], () => r(require('./list.vue')), 'device_device_list'),
    redirect: {name: 'device_device_list'},
    children: [
        {
            path: 'device_device_list',
            name: 'device_device_list',
            component: r => require.ensure([], () => r(require('./list.vue')), 'device_device_list'),
        }
    ]
}
